.riskDetailCallouts {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    /* Gap is 60 to align the callout header to the title of the page cells below */
    gap: 60px;
    margin-top: 10px;
}

.riskCategory,
.riskDetailStrategy,
.riskTags,
.riskOwner {
    display: flex;
    flex-direction: column;
    flex: 1 1 0px;
}

.riskTags {
    width: 100%;
    margin-top: 10px;
}

.headerButtons {
    display: flex;
    gap: 5px;
    margin-left: 20px;
}

.tagListing {
    margin-top: 5px;
}
